import React, { useState, useMemo, useEffect, useContext } from 'react'
import { identifyUser } from 'analytics/trackFunctions'
import storage from 'utils/storage'
import { useNavigate, useLocation } from 'react-router-dom'
import { getProfile } from '../api/profile'
import { UserContext } from './user'
import {
  NEW_TERMS_AND_CONDITIONS,
  UNACCEPTED_TERMS_AND_CONDITIONS,
  UNACCEPTED_SWORN_STATEMENT
} from '../constants/error'

export const MeContext = React.createContext()

export const MeProvider = (props) => {
  const [isLoadingMe, setIsLoadingMe] = useState(true)

  const [me, setMe] = useState(null)
  const [showTC, setShowTC] = useState(false)
  const [showPEP, setShowPEP] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const { user, setUser } = useContext(UserContext)

  function getProfileAndSetMe() {
    getProfile().then(({ data, error, success }) => {
      if (error) {
        setIsLoadingMe(false)
        if (
          error.code === NEW_TERMS_AND_CONDITIONS ||
          error.code === UNACCEPTED_TERMS_AND_CONDITIONS
        ) {
          return setShowTC(true)
        }
        if (error.code === UNACCEPTED_SWORN_STATEMENT) {
          return setShowPEP(true)
        }
      }

      if (success) {
        const { user: meUser, bank, profile } = data

        identifyUser(profile?.identification_number)

        if (meUser?.status === 'REJECTED_AUTO_AUDIT') {
          return navigate('/cuenta-rechazada', { replace: true })
        }

        if (
          meUser?.status === 'PENDING_AUDIT' ||
          meUser?.status === 'PENDING_TERMS' ||
          !bank?.internal_account.length ||
          !bank?.internal_account[0]?.cvu
        ) {
          return navigate('/pendiente', { replace: true })
        }

        setMe(data)
      }
    })
  }

  useEffect(() => {
    if (
      user &&
      location.pathname !== '/pendiente' &&
      location.pathname !== '/cuenta-rechazada'
    ) {
      setIsLoadingMe(true)
      setTimeout(() => {
        getProfileAndSetMe()
      }, 250)
    } else {
      setIsLoadingMe(false)
      setMe(null)
      setUser(null)
    }
  }, [user, location])

  useEffect(() => {
    if (JSON.stringify(me?.user) === '{}') {
      setUser(null)
      storage.del('user')
    }
  }, [me])

  const options = useMemo(
    () => ({
      me,
      setMe,
      showTC,
      setShowTc: setShowTC,
      showPEP,
      setShowPEP,
      isLoadingMe,
      setIsLoadingMe,
      getProfileAndSetMe
    }),
    [
      me,
      setMe,
      showTC,
      setShowTC,
      showPEP,
      setShowPEP,
      isLoadingMe,
      setIsLoadingMe,
      getProfileAndSetMe
    ]
  )

  return (
    <MeContext.Provider value={options} {...props} displayName='MeContext' />
  )
}
